module.exports = __webpack_public_path__ + "static/img/nav_bg.b94a9834.png";